export default "__VITE_ASSET__nOHO0f$k__"